import React from 'react';

import ErrorBoundary from 'components/ErrorBoundary';

import OwnerAssetRopaWorkspacePage from '../OwnerAssetRopaWorkspacePage/OwnerAssetRopaWorkspacePage';

/**
 * Asset Owner ROPA entry — permanent workspace with optional active review overlay (SAF-878).
 */
const OwnerAssetRopaPage: React.FC = () => (
  <ErrorBoundary>
    <OwnerAssetRopaWorkspacePage />
  </ErrorBoundary>
);

export default OwnerAssetRopaPage;
